export interface AuthApiOptions {
  clientId: string;
  tenant: string;
  redirectUri: string;
  endpoints: { [hostname: string]: string };
}

export const AUTH_AUTHORITY = 'https://login.microsoftonline.com/viacom.onmicrosoft.com';
export const DEFAULT_SCOPE = '/.default';
